Revolution.Module.extend({
    NAME: "mde.nav", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        _.bindAll(this, "showBtnExpendTouch");

        //Open submenu headerTop
        $('body').on('click', '.js-toggle-sub-menu', this.toggleSubMenu);
        $('body').on('click', '.js-close-sub-menu', this.closeSubMenus);
        $('body').click(this.closeSubMenus);

        $('body').on('click', '.js-toggle-sub-menu, .sub-menu-wrapper', function (e) {
            e.stopPropagation();
        });

        if (Modernizr.touchevents) {
            this.showBtnExpendTouch();
        }

        this.cloneLanguagesList();
        this.cloneSocialNetworkList();
        this.cloneSearchHeader();
        this.cloneOnTheWeb();
        this.cloneYouAre();
        this.cloneRestrictedAccess();

        $('.main-nav .js-btn-expend').on('click', this.openSubLevel);
        $('.main-nav .js-sublevel-back').on('click', this.closeSubLevel);


        this.stickyHeader();
        // this.iconsHeaderCondition();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
        if ($(window).width() >= 1024) {
            this.closeSubMenus();
        }
        this.stickyHeader();
    },

    closeSubMenus: function (e) {
        $('.sub-menu:visible').slideUp().prev('.js-toggle-sub-menu').removeClass('active').attr('aria-expanded', "false");
        $('body').removeClass('overflow-hidden');

        $('.js-bk-main-menu').css('margin-left', '0px');
        $('.sublevel-wrapper').removeAttr('style');
    },

    cloneLanguagesList: function () {
        $('.js-languages-list-copied').append($('.js-languages-list').clone());
    },

    cloneSocialNetworkList: function () {
        $('.js-social-network-copied').append($('.js-social-network').clone());
    },

    cloneSearchHeader: function () {
        $('.js-search-header-copied').append($('.js-search-header').clone());
    },

    cloneOnTheWeb: function () {
        $('.js-btn-on-the-web-copied').prepend($('.js-btn-on-the-web span.text').html());
        $('.js-btn-on-the-web-copied').prepend($('.js-btn-on-the-web > svg').clone());
        $('.js-bk-on-the-web-copied').append($('.js-bk-on-the-web').clone());
    },

    cloneYouAre: function () {
        $('.js-btn-you-are-copied').prepend($('.js-btn-you-are span.text').html());
        $('.js-btn-you-are-copied').prepend($('.js-btn-you-are > svg').clone());
        $('.js-bk-you-are-copied').append($('.js-bk-you-are').clone());
    },

    cloneRestrictedAccess: function () {
      $('.js-btn-restricted-access-copied').prepend($('.js-btn-restricted-access span.text').html());
      $('.js-btn-restricted-access-copied').prepend($('.js-btn-restricted-access > svg').clone());
      $('.js-bk-restricted-access-copied').append($('.js-bk-restricted-access').clone());
  },

    toggleSubMenu: function (e) {
        var $obj = $(e.currentTarget);
        var $subMenu = $obj.next('.sub-menu');
        if (!$obj.hasClass('active')) {
            $('.page-header-wrapper .sub-menu:visible').hide();
            $subMenu.slideDown();
            $obj.addClass('active').attr('aria-expanded', 'true');
            $('body').addClass('overflow-hidden');

            if ($subMenu.find('input[type="text"]').length && $(window).width() >= 1024) {
                $($subMenu.find('input[type="text"]')[0]).focus();
            }

            var UTILS = Revolution.get("mde._utils");
            UTILS.createFocusCycle($subMenu.find('.focus-first-item'), $subMenu.find('.focus-last-item'));

        } else {
            $subMenu.slideUp();
            $obj.removeClass('active').attr('aria-expanded', 'false');
        }
    },

    closeSubLevel: function (e) {
        e.preventDefault();
        var $obj = $(e.currentTarget);
        var $currentSubLevel = $obj.closest('.sublevel-wrapper');

        if ($currentSubLevel.parent().closest('.sublevel-wrapper').length) {
            var $previousLevel = $currentSubLevel.parent().closest('.sublevel-wrapper');
            var newMarginLeftCurrentSubLevel = parseInt($currentSubLevel.css('left')) + $(window).width();
            $currentSubLevel.css('left', newMarginLeftCurrentSubLevel + 'px');
            var newMarginLeftPreviousLevel = parseInt($previousLevel.css('left')) + $(window).width();
            $previousLevel.css('left', newMarginLeftPreviousLevel + 'px');
        } else {
            var $previousLevel = $currentSubLevel.closest('.js-bk-main-menu');
            var newMarginLeftCurrentSubLevel = parseInt($currentSubLevel.css('left')) + $(window).width();
            $currentSubLevel.css('left', newMarginLeftCurrentSubLevel + 'px');
            var newMarginLeftPreviousLevel = parseInt($previousLevel.css('margin-left')) + $(window).width();
            $previousLevel.css('margin-left', newMarginLeftPreviousLevel + 'px');
        }

    },

    openSubLevel: function (e) {
        e.preventDefault();
        var $obj = $(e.currentTarget);
        var $currentLi = $obj.closest('.js-level');
        var $currentSubLevel = $currentLi.find('> .sublevel-wrapper').focus();

        if ($obj.closest('.sublevel-wrapper').length) {
            var $previousLevel = $obj.closest('.sublevel-wrapper');
            var newMarginLeftPreviousLevel = parseInt($previousLevel.css('margin-left')) - $(window).width();
            $previousLevel.css('left', newMarginLeftPreviousLevel + 'px');
            var newMarginLeftCurrentSubLevel = parseInt($currentSubLevel.css('left')) - $(window).width();
            $currentSubLevel.css('left', newMarginLeftCurrentSubLevel + 'px');
        } else {
            var $previousLevel = $obj.closest('.js-bk-main-menu');
            var newMarginLeftPreviousLevel = parseInt($previousLevel.css('margin-left')) - $(window).width();
            $previousLevel.css('margin-left', newMarginLeftPreviousLevel + 'px');
            var newMarginLeftCurrentSubLevel = parseInt($currentSubLevel.css('left')) - $(window).width();
            $currentSubLevel.css('left', newMarginLeftCurrentSubLevel + 'px');
        }
    },

    showBtnExpendTouch: function () {
        if ($(window).width() < 1024) {
            $('.page-header-wrapper .main-nav .js-btn-expend').show();
        }
    },

    stickyHeader: function () {
        if ($(".page-header-wrapper[class*='headroom-']").length) {
            $(".page-header-wrapper").headroom("destroy");
        }

        var UTILS = Revolution.get("mde._utils");
        var offsetCalculated = UTILS.isMobile() ? 0 : $(".page-header-wrapper").find('.header-top').outerHeight();

        var options = {
            // vertical offset in px before element is first unpinned
            offset: offsetCalculated,
            // scroll tolerance in px before state changes
            tolerance: 0,
            // or you can specify tolerance individually for up/down scroll
            tolerance: {
                up: 0,
                down: 0
            },
        };

        $(".page-header-wrapper").headroom(options);
    },

    // iconsHeaderCondition: function () {
        // $('.bk-social-network').each(function() {
        //     if ($(this).width() === 0) {
        //         $(this).hide();
        //     } else {
        //         $(this).show();
        //     }
        // })
    // }
});
